import { InputFooter, InputHeader } from "@amzn/stencil-react-components/input";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Select } from "@amzn/stencil-react-components/select";
import React, { FC } from "react";
import { FormField } from "@/common/components/FormField/form-field";
import { getString } from "@/common/uistringlabels/ui-string-utils";

const STRING_PATH = "replacement.chooseDelivery.address";
const PHONE_CODE_PREFIX = /^\+\s*/;
const COUNTRY_CODE_WIDTH = 150;

export const PHONE_NUMBER_PATTERN = /^(?=.*\d)[0-9\s\-().]+$/;

export interface PhoneFieldBinding {
  testId: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  inputRef?: (instance: HTMLInputElement | HTMLTextAreaElement | null) => void;
  error?: string;
}

export interface PhoneNumberFieldsProps {
  countryCode: PhoneFieldBinding;
  phoneNumber: PhoneFieldBinding;
  phoneCodes: string[];
}

export const PhoneNumberFields: FC<PhoneNumberFieldsProps> = ({ countryCode, phoneNumber, phoneCodes }) => (
  <Row gridGap="S300" width="100%">
    <Col gridGap="S200" width={COUNTRY_CODE_WIDTH} flexShrink={0}>
      <InputHeader
        labelText={getString(`${STRING_PATH}.countryCode`)}
        htmlFor={countryCode.testId}
        required
        error={Boolean(countryCode.error)}
      />
      <Select
        id={countryCode.testId}
        dataTestId={countryCode.testId}
        isSearchable
        isMulti={false}
        width="100%"
        options={phoneCodes}
        placeholder={getString(`${STRING_PATH}.countryCodePlaceholder`)}
        noOptionsText={getString(`${STRING_PATH}.countryCodeLoading`)}
        value={countryCode.value ? `+ ${countryCode.value}` : undefined}
        error={Boolean(countryCode.error)}
        onChange={(value?: string) => countryCode.onChange(value?.replace(PHONE_CODE_PREFIX, "") ?? "")}
      />
      {countryCode.error && (
        <InputFooter id={`${countryCode.testId}-error`} error data-testid={`${countryCode.testId}-error`}>
          {countryCode.error}
        </InputFooter>
      )}
    </Col>
    <Col flex={1}>
      <FormField
        {...phoneNumber}
        label={getString(`${STRING_PATH}.phoneNumber`)}
        description={getString(`${STRING_PATH}.phoneNumberDescription`)}
        required
      />
    </Col>
  </Row>
);
